var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tel_wrapper"},[_c('div',{staticClass:"tel_all"},[_c('call-user-search'),_c('call-history')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }